import { zodResolver } from '@hookform/resolvers/zod';
import { getOpenedNodeData } from 'modules/workflows/ducks';
import { FC, PropsWithChildren } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { z } from 'zod';
import { FIELDS_MATCH_TOGGLE_IDS } from './YesNoSplitEditor.constants';

const schema = z.object({
  matchTriggeringEventFields: z.string(),
});

type YesNoSplitFormData = z.infer<typeof schema>;

export const YesNoSplitEditorFormProvider: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const initialNodeData = useSelector(getOpenedNodeData);
  const { matchTriggeringEventFields = false } = initialNodeData || {};

  const methods = useForm<YesNoSplitFormData>({
    defaultValues: {
      matchTriggeringEventFields: matchTriggeringEventFields
        ? FIELDS_MATCH_TOGGLE_IDS.TRIGGERING_EVENT
        : FIELDS_MATCH_TOGGLE_IDS.CONTACT_PROFILE,
    },
    mode: 'all',
    resolver: zodResolver(schema),
    shouldUnregister: true,
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
